export const COMPONENT_KEY =
  'talent-employee-pid-detail-or-record-tracking-component';
